import { createContext, useContext, useEffect, useState } from "react";
import useHttp from "../../../hooks/use-http";
import { useParams } from "react-router-dom";
import { apiGenerator } from "../../../util/functions";
import CONSTANTS from "../../../util/constant/CONSTANTS";
import { Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";

const WritePostContext = createContext();

export const ViewPostProvider = ({ children }) => {
  const API = useHttp();
  const APIGETPOST = useHttp();
  const { teamId, postId } = useParams();
  const [team, setTeam] = useState({});
  const [fileList, setFileList] = useState({});
  const [manualPost, setManualPost] = useState({});
  const [date, setDate] = useState(null);
  const [refersh, setRefersh] = useState(false);

  const getUpdatedData = () => {
    if (!teamId) return;
    API.sendBulkRequest(
      [
        apiGenerator(CONSTANTS.API.teams.getOne, { teamId }),
        apiGenerator(CONSTANTS.API.media.getAll, {}, `?teamId=${teamId}`),
      ],
      (res) => {
        setTeam(res?.[0]?.data?.data);
        setFileList(
          res?.[1]?.data?.data?.data?.reduce((acc, item) => {
            if (item?.id) {
              acc[item.id] = item;
            }
            return acc;
          }, {})
        );
      }
    );
  };

  useEffect(() => {
    if (postId)
      APIGETPOST.sendRequest(
        apiGenerator(CONSTANTS.API.post.getOne, { postId }),
        (res) => {
          setManualPost(res?.data);
          setDate(res?.data?.postDate);
        }
      );
  }, [postId, refersh]);

  useEffect(() => {
    getUpdatedData();
  }, [teamId]);

  return (
    <WritePostContext.Provider
      value={{
        team,
        manualPost,
        setManualPost,
        fileList,
        setFileList,
        setRefersh,
        date,
        setDate,
      }}
    >
      <Spin
        spinning={API?.isLoading || APIGETPOST?.isLoading}
        indicator={<LoadingOutlined style={{ fontSize: 48 }} spin />}
      >
        {children}
      </Spin>
    </WritePostContext.Provider>
  );
};

export const useWritePost = () => useContext(WritePostContext);
